// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"N--z","categoryName":"O--z","categoryImage":"P--z","categoryContent":"Q--z","bottomAligned":"R--z"};